import { Divider, HStack, Text, VStack } from "@chakra-ui/react";
import { FileFragment } from "gql/graphql";
import FileThumb from "modules/files/file-thumb";
import UserName from "modules/_shared/user-name";
import moment from "moment";
import React, { memo } from "react";
import colors from "app/colors";
import { MESSAGE_CALENDAR_FORMATS } from "modules/utils/Constants";

interface IProps {
  file: FileFragment;
  isLast: boolean;
}

const FileSelectionRow: React.FC<IProps> = ({ file, isLast }) => (
  <VStack pl={1}>
    <HStack spacing={3}>
      <FileThumb
        contentType={file.contentType}
        name={file.name}
        url={file.previewCloudFrontUrl}
        size={[54, 54]}
      />
      <VStack maxWidth={200} alignItems="flex-start" spacing={0}>
        <Text
          fontSize={14}
          fontWeight="bold"
          color={colors.gray50}
          noOfLines={1}
          maxW={130}
        >
          {file.name}
        </Text>
        <Text fontSize={14} color={colors.gray50} noOfLines={1}>
          <UserName userId={file.userId} />
        </Text>
        <Text color={colors.gray30} fontSize={12} fontWeight={500}>
          {moment(file.createTime).calendar(MESSAGE_CALENDAR_FORMATS)}
        </Text>
      </VStack>
    </HStack>
    {!isLast && <Divider />}
  </VStack>
);

export default memo(FileSelectionRow);
